<template>
  <button class="ui-button" :class="[variant, size ? ('size-' + size) : '']">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'UiButton',
  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.size-sm {
  padding: 4px 10px;
  font-size: 12px;
  line-height: 1;
}
.size-xs {
  padding: 2px 8px;
  font-size: 11px;
  line-height: 1;
}
</style>
